import {
  AttachFile, BusinessCenter, Class, Mail,
  MenuBook, NotificationsActive, School, Security,
  Storage as StorageIcon, Telegram, WhatsApp
} from '@mui/icons-material';

export const COLORS = {
  backgroundColorDarkTheme: '#1a2035',
  tableBackgroundColor: '#202940',
  tableHeaderColor: '#171f2f',
  borderColorDarkTheme: '#2F3957FF',
  fontColorDarkTheme: '#ffffff',
};

export const PLATFORMS_CONFIG = [
  { name: 'ActiveSoft', icon: <School fontSize="small" /> },
  { name: 'AppAlertAi', icon: <NotificationsActive fontSize="small" /> },
  { name: 'ClassApp', icon: <Class fontSize="small" /> },
  { name: 'ClipEscola', icon: <AttachFile fontSize="small" /> },
  { name: 'DefenseBridge', icon: <Security fontSize="small" /> },
  { name: 'Email', icon: <Mail fontSize="small" /> },
  { name: 'GVDASA', icon: <StorageIcon fontSize="small" /> }, 
  { name: 'Sophia', icon: <MenuBook fontSize="small" /> },
  { name: 'Telegram', icon: <Telegram fontSize="small" /> },
  { name: 'Unimestre', icon: <BusinessCenter fontSize="small" /> },
  { name: 'WhatsApp', icon: <WhatsApp fontSize="small" /> },
];
